module.exports = __webpack_public_path__ + "static/media/ecommerce.5d05b260.jpg";